import script from "./DangerButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DangerButton.vue?vue&type=script&setup=true&lang=ts"

import "./DangerButton.vue?vue&type=style&index=0&id=bf59fca4&scoped=true&lang=css"
import "./DangerButton.vue?vue&type=style&index=1&id=bf59fca4&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf59fca4"]])

export default __exports__